
export class EntTransportCategory {
    id: number = 0;
    alias: string = "";
    nameRu: string = "";
    nameKy: string = "";
}
